import { defineService } from '../../helpers.js';
export const SignalsServiceDefinition = defineService('core:signals');
